export default {
    Teacher: 1,
    Student: 2,
    SinglePlayer: 3
}
